import Vue from 'vue'
import Vuex from 'vuex'
import pathify from 'vuex-pathify'
import * as modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  modules,

  state: {
    drawer: false,
    links: [
      {
        name: 'Главная',
        url: 'Home',
      },
      {
        name: 'Обо мне',
        url: 'About me',
      },
      {
        name: 'Портфолио',
        url: 'Portfolio',
      },
      {
        name: 'Услуги',
        url: 'Services',
      },
      {
        name: 'Контакты',
        url: 'Contact',
      },
    ],
  },

  mutations: {
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
  },

  plugins: [pathify.plugin],
})
